export default {
    belongsToUser: null,
    settings: {
        name: {
            en: 'New Dashboard',
            de: 'Neues Dashboard'
        },
        description: {
            en: 'This Dashboard is only for you!',
            de: 'Dieses Dashboard ist nur für dich!'
        },
        showBorders: true,
        columns: 4
    },
    widgets: []
}